import { isUndefined } from 'lodash';
import { useState, useEffect, useMemo, useRef } from 'react';
import { getErrorMessage } from 'lib/input';

export const useInputText = ({ defaultValue, config, setInputs, field }) => {
  const { is_password = false, customErrorHandler, forceUpdate, is_number, readonly, customErrorMessage } = config;

  const isTouched = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [text, setText] = useState();
  const textFieldType = is_password && !showPassword ? 'password' : is_number ? 'number' : 'text';

  const errorMessage = useMemo(() => {
    if (customErrorHandler && text) {
      return customErrorHandler(text);
    }
    if (customErrorMessage) {
      return customErrorMessage;
    }
    return getErrorMessage({ schema: config, value: text });
  }, [config, text, customErrorHandler, customErrorMessage]);

  useEffect(() => {
    if (!isUndefined(defaultValue)) {
      setText(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (readonly) return;
    setInputs((v) => {
      return {
        ...v,
        [field]: {
          value: text,
          error: errorMessage,
          touched: forceUpdate ? true : !!isTouched.current
        }
      };
    });
    return () => {
      setInputs((v) => {
        return {
          ...v,
          [field]: undefined
        };
      });
    };
  }, [errorMessage, field, setInputs, text, readonly, forceUpdate]);

  return {
    textFieldType,
    errorMessage,
    isTouched,
    text,
    setText: (text) => {
      if (!isTouched.current) {
        isTouched.current = true;
      }

      setText(text);
    },
    showPassword,
    setShowPassword
  };
};
